import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "PrintableIframe" */ './lazyIndex')
);

export const lazyPrint = new LazyAction(lazyModule, m => m.print);
